'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactChartjs = require('react-chartjs-2');

var _colors = require('../../utils/colors');

var _formatting = require('../../utils/formatting');

var _constants = require('../../utils/constants');

var _demographics = require('../../utils/demographics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var options = {
  legend: {
    display: false
  },
  tooltips: {
    callbacks: {
      label: _formatting.getGraphLabelPercentageFormatting
    }
  }
};

var getViewsByGender = function getViewsByGender(data) {
  var values = (0, _demographics.reduceGraphDataByGender)(data);
  return {
    data: {
      labels: _lodash2.default.map(_lodash2.default.uniq(_lodash2.default.keys(values)), function (key) {
        return _lodash2.default.get(_constants.GENDERS, key).text || 'Unknown';
      }),
      datasets: [{
        data: _lodash2.default.map(values, function (value) {
          return _lodash2.default.sumBy(value, 'percentage');
        }),
        backgroundColor: [_colors.dyzioPalette.blue, _colors.dyzioPalette.pink],
        hoverBackgroundColor: [_colors.dyzioPalette.blue, _colors.dyzioPalette.pink]
      }]
    }
  };
};

var DemographicsGenderGraph = function DemographicsGenderGraph(_ref) {
  var data = _ref.audienceDemographics.data;

  var genderViewingData = getViewsByGender(data);
  return _react2.default.createElement(_reactChartjs.Doughnut, (0, _extends3.default)({}, genderViewingData, { options: options }));
};

DemographicsGenderGraph.propTypes = {
  audienceDemographics: _propTypes2.default.object.isRequired
};

exports.default = DemographicsGenderGraph;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/demographics-gender-graph/index.js
 ** module id = 379
 ** module chunks = 0
 **/